import routerOptions0 from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260917094529/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}